import type { ColumnDef } from '@tanstack/react-table'
import { CapabilityBadges } from 'v2/shared/components/capability-badges'
import { DestructiveConfirmPopupWithPermission } from 'v2/shared/components/destructive-confirm-popup-with-permission'
import type { RPlivoNumber } from 'v2/types/api/settings'
import { internationalFormat } from 'v2/utils'

export const getLinkedNumbersColumns = (
  onUnlink: (phoneNumber: string) => void,
  applicationName?: string,
  isTrunk = false,
): ColumnDef<RPlivoNumber>[] => [
  {
    accessorKey: 'number',
    header: 'Number & Area',
    cell: ({ row }) => {
      const number = row.original
      return (
        <div className="flex flex-col gap-1">
          <div className="text-xs-500 font-jetbrains tabular-nums">
            {internationalFormat(number.number)}
          </div>
          {number.region && <div className="text-s-400 text-secondary">{number.region}</div>}
        </div>
      )
    },
  },
  {
    accessorKey: 'number_type',
    header: 'Type',
    cell: ({ row }) => {
      const number = row.original
      return <span className="text-s-400 capitalize">{number.number_type || '—'}</span>
    },
  },
  {
    accessorKey: 'capability',
    header: 'Capability',
    cell: ({ row }) => {
      const rowData = row.original
      return (
        <CapabilityBadges
          voiceEnabled={rowData.voice_enabled}
          smsEnabled={rowData.sms_enabled}
          mmsEnabled={(rowData as { mms_enabled?: boolean }).mms_enabled}
          whatsappEnabled={(rowData as { whatsapp_enabled?: boolean }).whatsapp_enabled}
        />
      )
    },
  },
  {
    id: 'actions',
    header: '',
    cell: ({ row }) => {
      const number = row.original
      const formattedNumber = internationalFormat(number.number)
      return (
        <div className="flex justify-end">
          <DestructiveConfirmPopupWithPermission
            title={`Unlink Number from this ${isTrunk ? 'Trunk' : 'Application'}`}
            description={
              <div className="space-y-2">
                <p>
                  Are you sure you want to remove the number{' '}
                  <span className="text-p-600">{formattedNumber}</span> from your{' '}
                  {isTrunk ? 'Trunk' : 'Application'}{' '}
                  {applicationName ? <span className="text-p-600">{applicationName}</span> : ''}?
                </p>
              </div>
            }
            okButtonProps={{
              onClick: () => onUnlink(number.number.replace(/^\+/, '')),
            }}
            variant="ghost"
            size="sm"
            className="text-destructive hover:text-destructive"
            data-testid="button-unlink-number"
          >
            Unlink
          </DestructiveConfirmPopupWithPermission>
        </div>
      )
    },
  },
]
